import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { action } from 'typesafe-actions';
import { Prospect } from '../../api/talent/models/prospect.model';
import { prospectApi } from '../../api/talent/prospect-service';
import { planApi } from './../../api/talent/plan-service';
import { AppState } from './../app-state';
import { PlanActionTypes } from './plan-types';

export const getCurrentPlan = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(PlanActionTypes.GET_CURRENT_PLAN));
        try {
            const plan = await planApi.getPlan();
            dispatch(action(PlanActionTypes.GET_CURRENT_PLAN_SUCCESS, plan.data));
        } catch (error) {
            dispatch(action(PlanActionTypes.GET_CURRENT_PLAN_ERROR, error));
        }
    }
};

export const sendProspect = (prospect: Prospect) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(PlanActionTypes.SEND_PROSPECT));
    try {
      const response = await prospectApi.sendProspect(prospect);
      dispatch(action(PlanActionTypes.SEND_PROSPECT_SUCCESS, response.data));
    } catch (error) {
      dispatch(action(PlanActionTypes.SEND_PROSPECT_ERROR, error));
    }
  }
};
